<template lang="pug">
  b-container.page-container
    header-without-menu
    b-container.content.page-container
      b-row.header
        img(src="../../../assets/logo_big.svg")
      b-row.title
        div 파트너 계정 신청
      div.horizontal-line.mt-4
      b-row
        b-col.mt-4(cols="12")
          div.input-container
            span.text 신 청 업 체 :
            b-form-input(type="text", placeholder="신청 업체" v-model="form.companyName", @input="isValidCompanyName")
          div.input-container
            span.star *
            span 신청자 이름 :
            b-form-input(type="text", placeholder="신청자 이름" v-model="form.applicantName", @input="isValidName")
          div.input-container
            span.star *
            span 신청자 이메일 :
            b-form-input(type="text", placeholder="신청자 이메일" v-model="form.applicantEmail", @input="isValidEmail")
          div.input-container
            span.star *
            span 비 밀 번 호 :
            b-form-input(type="password", placeholder="영문 + 숫자 + 특수문자 (8자리 ~ 12자리) 이내로 입력하세요" v-model="form.applicantPw", @input="isValidPw")
          div.input-container
            span.text 신청자 연락처 :
            b-form-input(type="text", placeholder="신청자 연락처" v-model="form.applicantPhone", @input="isValidPhone")
          div.input-container
            span.star *
            span 업체 / 담당자 :
            div.company-container
              b-form-input(type="text", placeholder="업체 및 담당자" :value="this.form.managerName" disabled)
              b-button(variant="primary", @click="handleSelectButtonClick") 선택
          //div.input-container
          //  span.star *
          //  span 유효 기간 :
          //  div.data-picker-container
          //    b-form-datepicker(v-model="form.startPicked")
          //    span ~
          //    b-form-datepicker(v-model="form.endPicked")
          div.input-container
            b-button(variant="primary", @click="handleSendButtonClick",
              style="width: 6rem; font-size: 1.3rem; margin-top: 1.5rem") 신청
          div.input-container
            span.description ※ 열람 신청 후 7일 이내에 담당자 승인이 필요하며, 시간 초과시 다시 신청 바랍니다.
      div.horizontal-line.mt-4
      b-row.footer
        div.centered-content
          span COPYRIGHT 20232. KOINO Inc. all rights reserved.
</template>

<script>
import {HeaderWithoutMenu} from '../../mixins/header'


export default {
  name: 'partner-join',
  components: {HeaderWithoutMenu},
  methods: {
    isValidCompanyName () {
      this.validates.companyName = Boolean(this.form.companyName)
    },
    isValidName () {
      this.validates.applicantName = Boolean(this.form.applicantName)
    },
    isValidEmail () {
      const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      this.validates.applicantEmail = reg.test(this.form.applicantEmail)
    },
    isValidPw () {
      let pw = this.form.applicantPw
      if (/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,12}$/.test(pw)) {
        this.validates.applicantPw = true
      } else {
        this.validates.applicantPw = false
      }
    },
    isValidPhone () {
      this.validates.applicantPhone = Boolean(this.form.applicantPhone)
    },
    // 신청 버튼 눌렀을 경우에 관련된 메서드
    handleSendButtonClick() {
      const except = ['companyName', 'applicantPhone']

      for (const field of except) {
        if (!this.form[field]) {
          this.form[field] = '미기재';
        }
      }

      for (const field in this.form) {
        if (!except.includes(field) && (!this.validates[field] || !this.form[field])) {
          alert(this.messages[field])
          return
        }
      }

      console.log('신청버튼 클릭')
      console.log(this.form)
    },
    handleSelectButtonClick() {
      let params = {
        title: 'LinkMeMine',
        // context: {path: 'middle_manager_list_modal'},
        // userPk: this.userPk,
        // userType: this.user.member_type_id
      }
      this.AppState.$emit('show-company-select-modal', params)
    }
  },
  created() {
    this.AppState.$on('send-manager-info', data => {
      this.sendCompanyName = data[0]
      this.sendManagerName = data[1].name
      this.sendManagerInfo = data[1]
      this.form.managerName = `${this.sendCompanyName} / ${this.sendManagerName}`
    })
  },
  data() {
    return {
      form: {
        companyName: null,
        applicantName: null,
        applicantEmail: null,
        applicantPw: null,
        applicantPhone: null,
        managerName: null,
        startPicked: null,
        endPicked: null,
      },
      validates: {
        companyName: false,
        applicantName: false,
        applicantEmail: false,
        applicantPw: false,
        applicantPhone: false,
        // 분기문에서 언디파인드 때문에 어쩔 수 없이 true 추가함.
        managerName: true,
        startPicked: true,
        endPicked: true,
      },
      messages: {
        companyName: '업체명을 입력해주세요',
        applicantName: '신청자 이름을 입력해주세요',
        applicantEmail: '신청자 이메일을 올바른 형식으로 입력해주세요',
        applicantPw: '비밀번호를 올바른 형식으로 입력해주세요',
        managerName: '업체 / 담당자를 입력해주세요',
        startPicked: '유효기간 시작 날짜를 입력해주세요',
        endPicked: '유효기간 종료 날짜를 입력해주세요',
      },
      sendCompanyName: null,
      sendManagerName: null,
      sendManagerInfo: {},
    }
  }
}
</script>

<style scoped lang="scss">
.page-container {
  padding-top: 4rem;
}

.header {
  justify-content: center;
  margin-bottom: 2rem;

  > img {
    width: 17rem;
  }
}

.title {
  justify-content: center;
  margin: 3rem 0 0 0;

  > div {
    font-size: 2rem;
    font-weight: 550;
    letter-spacing: 1px;
  }
}

.horizontal-line {
  width: 70%;
  height: 3px;
  background-color: #7d7d7d;
  margin: 0 auto;
}

.input-container {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  margin: 1rem 0;

  span {
    display: inline-block;
    width: 8rem;
    font-size: 1.1rem;
  }

  .text {
    margin-left: 1rem;
  }

  .star {
    color: red;
    width: 1rem;
    font-size: 1.5rem;
  }

  .company-container {
    display: flex;
    width: 40%;
    margin-left: 1rem;

    .btn {
      margin-left: 1rem;
      width: 3.5rem;
      font-size: 0.75rem;
    }
  }

  .description {
    width: 100%;
    text-align: center;
  }

  .data-picker-container {
    display: flex;
    margin-left: 1rem;
    width: 40%;
    text-align: center;
    align-items: center;
  }

  > .form-control {
    margin-left: 1rem;
    width: 40%;
  }
}

.footer {
  justify-content: center;
  margin-top: 1.5rem;

  span {
    font-size: 0.9rem;
    font-weight: 350;
    letter-spacing: 2px;
  }
}

.centered-content {
  display: flex;
  align-items: center;
  justify-content: center;
}


</style>
